import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { PopoverAnchorProps } from '../types';
import { usePopoverContext } from '../PopoverContext';
import classes from './index.module.scss';

const PopoverAnchor = ({ children, as: Element = 'div', dataTestId }: PopoverAnchorProps) => {
  const {
    open,
    setOpen,
    triggerEvent,
    floatingData: { refs },
  } = usePopoverContext();
  const { isTouch } = getContext();

  const supportedEventListeners = {
    click: {
      onClick: () => {
        setOpen(!open);
      },
    },
    hover: {
      onMouseEnter: () => {
        setOpen(true);
      },
      onMouseLeave: () => {
        setOpen(false);
      },
    },
  };

  const eventListeners = isTouch ? supportedEventListeners.click : supportedEventListeners[triggerEvent];

  return (
    <Element className={classes.trigger} ref={refs.setReference} data-testid={dataTestId} {...eventListeners}>
      {children}
    </Element>
  );
};

PopoverAnchor.displayName = 'PopoverAnchor';

export default PopoverAnchor;
